export default __webpack_public_path__ + "static/media/GreyEllipse.40b96171.svg";